import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteOrderFOBActions } from "store/ducks/ordersFob";

export function* deleteOrderFOBRequest(action: any) {
  try {
    const { putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/orders-fob/delete`,
      putData
    );

    const { data } = responseBody;
    yield put(DeleteOrderFOBActions.success(data));
    notify("success", "Ordem deletada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteOrderFOBActions.failure(errorMessage));
  }
}
